import * as Yup from 'yup';

const createValidationSchema = (dynamicProperties:any) => {
    let validationSchema = Yup.object().shape({});
    // Dynamically add fields to the schema based on dynamicProperties
    Object.keys(dynamicProperties).forEach((property:any) => {
      validationSchema = validationSchema.shape({
        [property]: Yup.string().required('US.USC.TEMPLATEEDITOR:VALIDATIONS.THIS_FIELD_IS_REQUIRED'),
      });
    });
  
    return validationSchema;
  };
  
  export default createValidationSchema;